import React, {useContext, useEffect, useState} from "react";
import { useTranslation } from "react-i18next";

import { CButton, CImage } from "@app/components/Common";
import { COLORS } from "@app/constants";
// import { useChangeLanguage } from "../hooks";
import { LanguageModalBodyWrapper } from "./styles";
import { useFetcherPublic } from "@app/hooks/fetcher";
import { ThemeContext } from "@/theme/ThemeProvider";
import { View } from "@/styles/reactnative";
import { IconCheck } from "@tabler/icons-react";
import {getSetting, useSetting} from "@app/hooks/user/mysetting.tsx";
import {SETTING_TYPE_SYSTEM} from "@app/constants/SETTING.tsx";

const CurrencyModalBody = ({ closeModal }) => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const { isDarkMode } = useContext(ThemeContext);
  const { i18n } = useTranslation();
  // useChangeLanguage(lang);

  // const CurrencyData = [
  //   {
  //     "code": "DE",
  //     "name": "£ GBP",
  //   },
  //   {
  //     "code": "EN",
  //     "name": "$ USD",
  //   },
  //   {
  //     "code": "IT",
  //     "name": "€ EUR ",
  //   },
  //   {
  //     "code": "JA",
  //     "name": "¥ JPY",
  //   },
  //   {
  //     "code": "ZH",
  //     "name": "¥ CNY",
  //   }
  // ]

  const { data: setting, updateSetting } = useSetting(SETTING_TYPE_SYSTEM);
  const { data: result } = useFetcherPublic("/system/currency");
  const currency = getSetting(setting, "CURRENCY", "USD");
  const currencyOptions = result?.result?.result?.map((item: any) => ({
    code: item.code,
    name: item.name,
  }));

  const defaultCurrency = currencyOptions?.find(
    (item: any) => item.code === currency,
  );

  const [lang, setLang] = useState(defaultCurrency);


  return (
    <LanguageModalBodyWrapper>
      {currencyOptions.map((item: any, index: number) => (
        <View
          key={index.toString()}
          style={{
            flexDirection: "row",
            width: "50%",
            background:
              item?.code === lang.code
                ? isDarkMode
                  ? "#f1f1f1"
                  : "rgba(217, 217, 217, 0.1)"
                : "transparent",
            alignItems: "center",
            justifyContent: "space-between",
            paddingLeft: 15,
            paddingBlock: 10,
            borderRadius: 5,
            marginTop: 4,
            paddingRight: 15,
            cursor:'pointer'
          }}
        >
          <CButton
            title={item?.name}
            icon={
              item?.image ?
              <CImage
                src={item?.image}
                alt="logo"
                width={18}
                height={18}
                resizeMode={"cover"}
                style={{ borderRadius: 50, marginRight: 7}}
              />
                :
                <></>
            }
            onClick={() => {
              setLang(item?.code?.toLowerCase());
              updateSetting("CURRENCY", item?.code);
              setImmediate(() => {
                closeModal && closeModal();
              });
            }}
            style={{
              fontSize: 13,
              color:
                item?.code === lang.code
                  ? COLORS.primary
                  : textw,
              flexDirection: "row-reverse",
            }}
          />
          {item?.code === lang.code ? (
            <IconCheck size={14} color={COLORS.primary} />
          ) : null}
        </View>
      ))}
    </LanguageModalBodyWrapper>
  );
};

export default CurrencyModalBody;
